import React from "react";
import { format } from "date-fns";
import { XIcon } from "lucide-react";

export interface CalendarDatesListProps {
  dates: Date[];
  onDelete: (date: number) => void;
}

const classes = {
  Wrapper: "",
  ItemsContainer: "flex flex-col flex-wrap gap-4",
  Item: "flex justify-between items-center w-[149px] text-sm text-ink font-[400] cursor-pointer hover:text-primary-1000 rounded-lg select-none",
  NoItems: "w-[149px] text-sm text-neutral-600 text-center font-[400]"
};

export const CalendarDatesList: React.FC<CalendarDatesListProps> = ({
  dates,
  onDelete
}) => {
  const selectedSorted = React.useMemo(
    () => dates.sort((a, b) => a.getTime() - b.getTime()),
    [dates]
  );

  return (
    <div className={classes.Wrapper}>
      <div className={classes.ItemsContainer}>
        {selectedSorted.length ? (
          selectedSorted.map((date: Date, dateIndex) => (
            <div
              className={classes.Item}
              key={date.getTime().toString()}
              onClick={() => {
                onDelete(dateIndex);
              }}
            >
              <span title={format(date, "EEE, M/d/yyyy")}>
                {format(date, "EEE, MMM d")}
              </span>
              <button
                className="text-muted-foreground"
                onClick={() => {
                  onDelete(dateIndex);
                }}
              >
                <XIcon className="h-4 w-4" />
              </button>
            </div>
          ))
        ) : (
          <div className={classes.NoItems}>Select a date</div>
        )}
      </div>
    </div>
  );
};
